import { useList, useDetail, useCreate, useUpdate, useDelete, useAction } from "@inmagik/react-crud"
import { Sequenza } from "../types"
import { API_URL } from "../constants"

export function useSequenzeList(params: Record<string, string> = {}) {
  return useList<Sequenza>(`${API_URL}/sequenze`, {
    query: params,
  })
}

export function useSequenza(id: number | undefined | string) {
  return useDetail<Sequenza>(`${API_URL}/sequenze`, id?.toString())
}

export function useSequenzaCreate() {
  return useCreate<Sequenza>(`${API_URL}/sequenze`)
}

export function useSequenzaUpdate() {
  return useUpdate<Sequenza>(`${API_URL}/sequenze`)
}

export function useSequenzaDelete() {
  return useDelete<Sequenza>(`${API_URL}/sequenze`)
}


export type SequenzeImportPayload = {
  file: File
  commit: boolean
}

export type SequenzeImportResponse = {
  sequenze_update: string[],
  sequenze_new: string[],
  errors: Record<string, Record<string, string>>
}

export function useSequenzeImport() {
  return useAction<SequenzeImportResponse, SequenzeImportPayload>(`${API_URL}/sequenze/import-xlsx`, {
    method: "POST",
    encode: "formdata",
  })
}

